import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/newsletter/mail.webp")